$(function () {
    var redirectUrl = localStorage.getItem("redirect_url");
  
    if(redirectUrl == null || redirectUrl == ""){
      var devRef = document.referrer;
      var url = new URL(devRef);
      var path = url.pathname
      
      $('.devRedirect2').val(path);
    }
    else{
      $('.devRedirect2').val(redirectUrl);
    }
  });